import React from 'react';
import InnerTargetField from '../InnerTargetField';
import TargetFieldDossierTypeField from './DossierTypeField';


const TargetFieldDataForDossier = ({ fieldName, readOnly = false }) => {
  return (
    <>
      <TargetFieldDossierTypeField fieldName={fieldName} readOnly={readOnly}/>
      <InnerTargetField fieldName={fieldName} readOnly={readOnly}/>
    </>
  );
};

export default TargetFieldDataForDossier;